import React, { Fragment, useEffect, useState } from "react";
import { fetchTemplates } from "../../Admin/Templates";
import { DashboardTopBarContainerContent } from "../Dashboard/Style";
import { DataTableToolbar } from "../../../components/data-table/data-table-toolbar";
import DataTable from "../../../components/data-table/data-table";
import { columns } from "../../../config/templates";
import {
    ColumnFiltersState,
    getCoreRowModel,
    getFacetedRowModel,
    getFacetedUniqueValues,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
    VisibilityState,
} from "@tanstack/react-table";
import { DataTableToolbarButton } from "../../../types/table";
import { useNavigate } from "react-router";
import { EditTemplateModal } from "./Modals/EditTemplateModal";
import { TemplateItem } from "../../../types/Central";

export function AdminTemplatesPage() {
    const [data, setData] = useState<Array<TemplateItem>>([]);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [selectEdit, setSelectEdit] = useState<TemplateItem | undefined>(undefined);
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({}),
        [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]),
        [sorting, setSorting] = useState<SortingState>([]),
        table = useReactTable({
            data,
            columns,
            state: {
                sorting,
                columnVisibility,
                columnFilters,
            },
            initialState: {
                pagination: {
                    pageSize: 20,
                },
            },
            onSortingChange: setSorting,
            onColumnFiltersChange: setColumnFilters,
            onColumnVisibilityChange: setColumnVisibility,
            getCoreRowModel: getCoreRowModel(),
            getFilteredRowModel: getFilteredRowModel(),
            getPaginationRowModel: getPaginationRowModel(),
            getSortedRowModel: getSortedRowModel(),
            getFacetedRowModel: getFacetedRowModel(),
            getFacetedUniqueValues: getFacetedUniqueValues(),
        });
    const navigate = useNavigate();

    useEffect(() => {
        if (data.length === 0) {
            fetchData();
        }
    }, []);

    function fetchData() {
        fetchTemplates().then((data) => {
            setData(
                data.data.sort(
                    (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
                ),
            );
        });
    }

    function handleOnClick(row: TemplateItem) {
        setShowEditModal(true);
        setSelectEdit(row);
    }

    function handleClose() {
        setSelectEdit(undefined);
        setShowEditModal(false);
        fetchData();

        const active = document.getElementsByClassName("active-table-row")[0];
        if (active) {
            active.classList.remove("active-table-row");
        }
    }

    function newEntry() {
        navigate("new");
    }

    const buttons: Array<DataTableToolbarButton> = [
        {
            label: "+ NEW TEMPLATE",
            action: () => newEntry(),
        },
    ];

    return (
        <Fragment>
            {selectEdit && (
                <EditTemplateModal
                    open={showEditModal}
                    onClose={handleClose}
                    template={selectEdit}
                />
            )}
            <Fragment>
                <DashboardTopBarContainerContent>
                    <div className="flex flex-col h-full">
                        <DataTableToolbar
                            table={table}
                            title="Templates"
                            searchableColumns={["template_type", "name", "active"]}
                            buttons={buttons}
                        />
                        <div className="flex py-4 h-full">
                            <DataTable columns={columns} table={table} onClick={handleOnClick} />
                        </div>
                    </div>
                </DashboardTopBarContainerContent>
            </Fragment>
        </Fragment>
    );
}
